import { GraphQLResult } from '@aws-amplify/api-graphql';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, graphqlOperation } from 'aws-amplify';

type TemplateType = 'player' | 'user';
export const templateTypePlayer: TemplateType = 'player';
export const templateTypeUser: TemplateType = 'user';

const getTemplateURLQuery = `query MyQuery($input: GetTemplateURLInput!) {
  getTemplateURL(input: $input)
  }`;

export const downloadPlayerTemplateThunk = createAsyncThunk<
  string,
  TemplateType
>('template/downloadPlayerTemplateThunk', async (templateType, thunkApi) => {
  try {
    const result = (await API.graphql(
      graphqlOperation(getTemplateURLQuery, {
        input: { type: templateType },
      }),
    )) as GraphQLResult<{ getTemplateURL: string }>;

    if (!result?.data?.getTemplateURL) {
      return thunkApi.rejectWithValue({
        message: 'bulk upload spreadsheet template was not found',
      });
    }
    return result.data.getTemplateURL;
  } catch (error) {
    return thunkApi.rejectWithValue({
      message: error,
    });
  }
});
